<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Object</button>
  
            <div class="personal-details">
                <h4 class="personal-details-title">Object Type Group List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let object of objectData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                      }  ;let i = index">
                      <th scope="col">{{object.group}}</th>
                      <th scope="col">{{object.type}}</th>
                    </tr>    
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="objectData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div>
  
        </div>
    </div>
  </div>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Object
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
            <div class="row">
                <div class="col-md-12 col-lg-12">
                    <div formArrayName="groupTypeList">
                        <div *ngFor="let param of form.controls.groupTypeList['controls'];let i = index;let last = last" [formGroupName]="i">
                            <div class="row">
                                <div class="col-md-5 col-lg-5">
                                    <div class="form-group">
                                        <input formControlName="group" placeholder="enter group" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <input formControlName="type" placeholder="enter type" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addGroupTypeList()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removeGroupTypeList(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removeGroupTypeList(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" id="submit" (click)="addObjectTypeAndGroup()" class="btn btn-primary">Add Object</button>
      </div>
    </div>
  </div>
  </div>
  
  



 
<!-- <div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Status Details
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body view">
    
          <div *ngFor="let status of singleStatusMaster">
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Name</label>
                          <input type="text" value="{{status.name}}" class="form-control">
                      </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Status Type</label>
                      <select name="" id="" formControlName="type" class="form-control">
                        <option value="" disabled selected hidden>---select type---</option>
                        <option value="{{status}}" *ngFor="let status of statusTypes">{{status}}</option>
                      </select>
                    </div>
                  </div>
                
                  
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea class="form-control" value="{{status.description}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                
              </div>
          </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
    </div>
    </div> -->
